import React, { type FC } from 'react';
import type { Option } from '../DropdownProps';
import Styles from '../styles.scss';
import MultiSelectOptions from './MultiSelectOptions';
import SingleSelectOptions from './SingleSelectOptions';

interface DropdownProps {
	onSelectionChange?: (stagedOptions: string[]) => void;
	options: Option[];
	setStagedOptions: (stagedOptions: string[]) => void;
	stagedOptions: string[];
	singleSelect?: boolean;
	defaultOptions?: string[];
	isFilterPolishEnabled?: boolean;
}

const Dropdown: FC<DropdownProps> = ({
	onSelectionChange,
	options,
	setStagedOptions,
	stagedOptions,
	singleSelect,
	defaultOptions,
	isFilterPolishEnabled,
}) => {
	const selected =
		stagedOptions.length === 0 && defaultOptions
			? defaultOptions
			: stagedOptions;

	const updateSelections = (selections: string[]) => {
		if (onSelectionChange) {
			onSelectionChange(selections);
		}
		setStagedOptions(selections);
	};

	return (
		<>
			<div className={Styles.options}>
				{singleSelect ? (
					<SingleSelectOptions
						options={options}
						selected={selected}
						setSelected={updateSelections}
						isFilterPolishEnabled={isFilterPolishEnabled}
					/>
				) : (
					<MultiSelectOptions
						options={options}
						selected={selected}
						setSelected={updateSelections}
						isFilterPolishEnabled={isFilterPolishEnabled}
					/>
				)}
			</div>
		</>
	);
};

export default Dropdown;
